var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdatedRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4833 9.22261C24.1675 8.74891 23.5094 8.64353 23.062 8.95932C22.5883 9.27512 22.4566 9.9596 22.7987 10.4333C24.0096 12.1441 24.6412 14.3026 24.4306 16.5927C24.0358 20.9359 20.535 24.4366 16.1918 24.8578C10.4536 25.4106 5.61036 20.6462 6.11047 14.908C6.50523 10.249 10.4273 6.61661 15.0863 6.51132V8.19593C15.0863 8.80129 15.7706 9.1698 16.2707 8.85398L20.6138 6.14281C21.1139 5.827 21.1139 5.11625 20.6138 4.82671L16.2707 2.11554C15.7443 1.79973 15.0863 2.16824 15.0863 2.77359V4.4582C9.45337 4.53715 4.76805 8.69605 4.08368 14.329C3.24128 21.3306 8.87429 27.2794 15.797 26.9899C21.5352 26.7266 26.2468 22.0676 26.5364 16.3294C26.668 13.671 25.8783 11.223 24.4832 9.22249L24.4833 9.22261Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatedRefresh);
export default __webpack_public_path__ + "static/media/UpdatedRefresh.85622d9328b64adcf2d35c466a73d3d6.svg";
export { ForwardRef as ReactComponent };